"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2],{

/***/ 2002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ general_Layout; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(6835);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
;// CONCATENATED MODULE: ./assets/svg/menu/logo.svg
var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 171,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/react.createElement("rect", {
    y: 11.001,
    width: 33,
    height: 8,
    rx: 4,
    fill: "#FADA50"
  })), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M6 4.94c0-.657.331-1.273.887-1.623 6.85-4.3 11.124-4.54 18.237-.002.55.35.876.964.876 1.617 0 1.08-.876 1.956-1.956 1.956H7.948A1.948 1.948 0 0 1 6 4.939ZM6 24.95c0 .656.331 1.272.887 1.621 6.85 4.301 11.124 4.54 18.237.003.55-.35.876-.964.876-1.617 0-1.08-.876-1.956-1.956-1.956H7.948A1.948 1.948 0 0 0 6 24.95ZM45.125 23.443v-16.8h8.208c2.112 0 3.696.4 4.752 1.2 1.072.8 1.608 1.856 1.608 3.168 0 .88-.216 1.648-.648 2.304-.432.64-1.024 1.136-1.776 1.488-.752.352-1.616.528-2.592.528l.456-.984c1.056 0 1.992.176 2.808.528.816.336 1.448.84 1.896 1.512.464.672.696 1.496.696 2.472 0 1.44-.568 2.568-1.704 3.384-1.136.8-2.808 1.2-5.016 1.2h-8.688Zm3.864-2.928h4.536c1.008 0 1.768-.16 2.28-.48.528-.336.792-.864.792-1.584 0-.704-.264-1.224-.792-1.56-.512-.352-1.272-.528-2.28-.528H48.7v-2.832h4.152c.944 0 1.664-.16 2.16-.48.512-.336.768-.84.768-1.512 0-.656-.256-1.144-.768-1.464-.496-.336-1.216-.504-2.16-.504h-3.864v10.944Zm20.631 3.12c-1.472 0-2.768-.288-3.888-.864-1.104-.576-1.96-1.36-2.568-2.352-.608-1.008-.912-2.152-.912-3.432 0-1.296.296-2.44.888-3.432a6.353 6.353 0 0 1 2.472-2.352c1.04-.576 2.216-.864 3.528-.864 1.264 0 2.4.272 3.408.816a5.896 5.896 0 0 1 2.424 2.304c.592.992.888 2.184.888 3.576 0 .144-.008.312-.024.504l-.048.504H65.3V15.86h8.52l-1.44.648c0-.672-.136-1.256-.408-1.752a2.895 2.895 0 0 0-1.128-1.152c-.48-.288-1.04-.432-1.68-.432-.64 0-1.208.144-1.704.432-.48.272-.856.664-1.128 1.176-.272.496-.408 1.088-.408 1.776v.576c0 .704.152 1.328.456 1.872.32.528.76.936 1.32 1.224.576.272 1.248.408 2.016.408.688 0 1.288-.104 1.8-.312a4.378 4.378 0 0 0 1.44-.936l1.992 2.16c-.592.672-1.336 1.192-2.232 1.56-.896.352-1.928.528-3.096.528Zm15.141 0c-1.472 0-2.768-.288-3.888-.864-1.104-.576-1.96-1.36-2.568-2.352-.608-1.008-.912-2.152-.912-3.432 0-1.296.296-2.44.888-3.432a6.353 6.353 0 0 1 2.472-2.352c1.04-.576 2.216-.864 3.528-.864 1.264 0 2.4.272 3.408.816a5.896 5.896 0 0 1 2.424 2.304c.592.992.888 2.184.888 3.576 0 .144-.008.312-.024.504l-.048.504H80.441V15.86h8.52l-1.44.648c0-.672-.136-1.256-.408-1.752a2.895 2.895 0 0 0-1.128-1.152c-.48-.288-1.04-.432-1.68-.432-.64 0-1.208.144-1.704.432-.48.272-.856.664-1.128 1.176-.272.496-.408 1.088-.408 1.776v.576c0 .704.152 1.328.456 1.872.32.528.76.936 1.32 1.224.576.272 1.248.408 2.016.408.688 0 1.288-.104 1.8-.312a4.378 4.378 0 0 0 1.44-.936l1.992 2.16c-.592.672-1.336 1.192-2.232 1.56-.896.352-1.928.528-3.096.528Zm8.997-.192v-16.8h3.888v13.632h8.424v3.168H93.758Zm20.294.192c-1.376 0-2.6-.288-3.672-.864a6.726 6.726 0 0 1-2.52-2.352c-.608-1.008-.912-2.152-.912-3.432 0-1.296.304-2.44.912-3.432a6.482 6.482 0 0 1 2.52-2.352c1.072-.576 2.296-.864 3.672-.864 1.36 0 2.576.288 3.648.864 1.072.56 1.912 1.336 2.52 2.328.608.992.912 2.144.912 3.456 0 1.28-.304 2.424-.912 3.432-.608.992-1.448 1.776-2.52 2.352-1.072.576-2.288.864-3.648.864Zm0-3.072c.624 0 1.184-.144 1.68-.432a3.095 3.095 0 0 0 1.176-1.224c.288-.544.432-1.184.432-1.92 0-.752-.144-1.392-.432-1.92a3.095 3.095 0 0 0-1.176-1.224 3.284 3.284 0 0 0-1.68-.432c-.624 0-1.184.144-1.68.432a3.266 3.266 0 0 0-1.2 1.224c-.288.528-.432 1.168-.432 1.92 0 .736.144 1.376.432 1.92.304.528.704.936 1.2 1.224a3.284 3.284 0 0 0 1.68.432Zm15.822 3.072c-1.392 0-2.632-.28-3.72-.84-1.088-.576-1.944-1.368-2.568-2.376-.608-1.008-.912-2.152-.912-3.432 0-1.296.304-2.44.912-3.432a6.4 6.4 0 0 1 2.568-2.352c1.088-.576 2.328-.864 3.72-.864 1.36 0 2.544.288 3.552.864a5.132 5.132 0 0 1 2.232 2.424l-2.904 1.56c-.336-.608-.76-1.056-1.272-1.344a3.192 3.192 0 0 0-1.632-.432c-.64 0-1.216.144-1.728.432-.512.288-.92.696-1.224 1.224-.288.528-.432 1.168-.432 1.92s.144 1.392.432 1.92c.304.528.712.936 1.224 1.224a3.463 3.463 0 0 0 1.728.432c.592 0 1.136-.136 1.632-.408.512-.288.936-.744 1.272-1.368l2.904 1.584a5.282 5.282 0 0 1-2.232 2.424c-1.008.56-2.192.84-3.552.84Zm15.86-.192v-2.52l-.24-.552V15.86c0-.8-.248-1.424-.744-1.872-.48-.448-1.224-.672-2.232-.672-.688 0-1.368.112-2.04.336-.656.208-1.216.496-1.68.864l-1.344-2.616c.704-.496 1.552-.88 2.544-1.152.992-.272 2-.408 3.024-.408 1.968 0 3.496.464 4.584 1.392 1.088.928 1.632 2.376 1.632 4.344v7.368h-3.504Zm-3.936.192c-1.008 0-1.872-.168-2.592-.504-.72-.352-1.272-.824-1.656-1.416a3.582 3.582 0 0 1-.576-1.992c0-.768.184-1.44.552-2.016.384-.576.984-1.024 1.8-1.344.816-.336 1.88-.504 3.192-.504h3.432v2.184h-3.024c-.88 0-1.488.144-1.824.432-.32.288-.48.648-.48 1.08 0 .48.184.864.552 1.152.384.272.904.408 1.56.408.624 0 1.184-.144 1.68-.432.496-.304.856-.744 1.08-1.32l.576 1.728c-.272.832-.768 1.464-1.488 1.896-.72.432-1.648.648-2.784.648Zm10.828-.192V5.635h3.744v17.808h-3.744Zm11.563.192c-1.104 0-2.168-.128-3.192-.384-1.008-.272-1.808-.608-2.4-1.008l1.248-2.688c.592.368 1.288.672 2.088.912a9.042 9.042 0 0 0 2.4.336c.864 0 1.472-.104 1.824-.312.368-.208.552-.496.552-.864 0-.304-.144-.528-.432-.672-.272-.16-.64-.28-1.104-.36a54.25 54.25 0 0 0-1.536-.24 21.417 21.417 0 0 1-1.656-.312 5.949 5.949 0 0 1-1.536-.624 3.239 3.239 0 0 1-1.128-1.104c-.272-.464-.408-1.064-.408-1.8 0-.816.232-1.536.696-2.16.48-.624 1.168-1.112 2.064-1.464.896-.368 1.968-.552 3.216-.552.88 0 1.776.096 2.688.288.912.192 1.672.472 2.28.84l-1.248 2.664a6.07 6.07 0 0 0-1.896-.744 8.1 8.1 0 0 0-1.824-.216c-.832 0-1.44.112-1.824.336-.384.224-.576.512-.576.864 0 .32.136.56.408.72.288.16.664.288 1.128.384.464.096.968.184 1.512.264.56.064 1.12.168 1.68.312.56.144 1.064.352 1.512.624.464.256.84.616 1.128 1.08.288.448.432 1.04.432 1.776 0 .8-.24 1.512-.72 2.136-.48.608-1.176 1.088-2.088 1.44-.896.352-1.992.528-3.288.528Z",
    fill: "#0074FF"
  })));
};
/* harmony default export */ var logo = (SvgLogo);
;// CONCATENATED MODULE: ./assets/svg/menu/menu.svg
var menu_rect, _rect2, _rect3;
function menu_extends() { menu_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return menu_extends.apply(this, arguments); }

var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/react.createElement("svg", menu_extends({
    width: 25,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), menu_rect || (menu_rect = /*#__PURE__*/react.createElement("rect", {
    width: 25,
    height: 3,
    rx: 1.5,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/react.createElement("rect", {
    y: 6,
    width: 25,
    height: 3,
    rx: 1.5,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/react.createElement("rect", {
    y: 12,
    width: 25,
    height: 3,
    rx: 1.5,
    fill: "#fff"
  })));
};
/* harmony default export */ var menu = (SvgMenu);
;// CONCATENATED MODULE: ./assets/svg/menu/menuLogo.svg
var menuLogo_rect, menuLogo_path;
function menuLogo_extends() { menuLogo_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return menuLogo_extends.apply(this, arguments); }

var SvgMenuLogo = function SvgMenuLogo(props) {
  return /*#__PURE__*/react.createElement("svg", menuLogo_extends({
    width: 33,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), menuLogo_rect || (menuLogo_rect = /*#__PURE__*/react.createElement("rect", {
    y: 11.001,
    width: 33,
    height: 8,
    rx: 4,
    fill: "#FADA50"
  })), menuLogo_path || (menuLogo_path = /*#__PURE__*/react.createElement("path", {
    d: "M6 4.94c0-.657.331-1.273.887-1.623 6.85-4.3 11.124-4.54 18.237-.002.55.35.876.964.876 1.617 0 1.08-.876 1.956-1.956 1.956H7.948A1.948 1.948 0 0 1 6 4.939ZM6 24.95c0 .656.331 1.272.887 1.621 6.85 4.301 11.124 4.54 18.237.003.55-.35.876-.964.876-1.617 0-1.08-.876-1.956-1.956-1.956H7.948A1.948 1.948 0 0 0 6 24.95Z",
    fill: "#263238"
  })));
};
/* harmony default export */ var menuLogo = (SvgMenuLogo);
;// CONCATENATED MODULE: ./assets/svg/menu/close.svg
var close_rect, close_rect2;
function close_extends() { close_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return close_extends.apply(this, arguments); }

var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/react.createElement("svg", close_extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), close_rect || (close_rect = /*#__PURE__*/react.createElement("rect", {
    x: 2,
    y: 4.121,
    width: 3,
    height: 18.31,
    rx: 1.5,
    transform: "rotate(-45 2 4.121)",
    fill: "#323C46"
  })), close_rect2 || (close_rect2 = /*#__PURE__*/react.createElement("rect", {
    x: 14.947,
    y: 2,
    width: 3,
    height: 18.31,
    rx: 1.5,
    transform: "rotate(45 14.947 2)",
    fill: "#323C46"
  })));
};
/* harmony default export */ var menu_close = (SvgClose);
;// CONCATENATED MODULE: ./assets/svg/menu/arrowDown.svg
var _g, _defs;
function arrowDown_extends() { arrowDown_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrowDown_extends.apply(this, arguments); }

var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/react.createElement("svg", arrowDown_extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#arrowDown_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M21.01 7.38c.49.49.49 1.28 0 1.77l-8.31 8.31a.996.996 0 0 1-1.41 0L2.98 9.15a1.25 1.25 0 0 1 0-1.77 1.25 1.25 0 0 1 1.77 0L12 14.62l7.25-7.25c.48-.48 1.28-.48 1.76.01Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "arrowDown_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    transform: "matrix(0 1 1 0 0 0)",
    d: "M0 0h24v24H0z"
  })))));
};
/* harmony default export */ var arrowDown = (SvgArrowDown);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./components/utilities/Collapse.js
var Collapse = __webpack_require__(6006);
// EXTERNAL MODULE: ./styles/styles.js
var styles = __webpack_require__(6808);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 30 modules
var esm = __webpack_require__(8992);
// EXTERNAL MODULE: ./data/colors.ts
var colors = __webpack_require__(7309);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/home/Menu.tsx

















var Header = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
  displayName: "Menu__Header",
  componentId: "sc-ltx7l2-0"
})(["width:100%;position:sticky;top:0;z-index:1;left:0;padding:0.75rem 1.5rem;background:", ";@media ", "{&.not-stuck{background:transparent;.desktop-link{color:", ";}button{background:", ";color:", ";box-shadow:none;}}}"], styles/* WHITE */.Cj, styles/* device.laptopSmall */.Uh.laptopSmall, styles/* WHITE */.Cj, styles/* WHITE */.Cj, styles/* MAINCOLOR */.Ku);
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Menu__Container",
  componentId: "sc-ltx7l2-1"
})(["width:100%;max-width:1300px;margin:auto;display:flex;align-items:center;justify-content:space-between;.desktop-contact-us-button{display:none;}@media ", "{#logo{max-width:15rem !important;}.desktop-contact-us-button{display:block;}}"], styles/* device.laptopSmall */.Uh.laptopSmall);
var MobileMenuButton = (0,styled_components_browser_esm/* default */.ZP)(styles/* Button */.zx).withConfig({
  displayName: "Menu__MobileMenuButton",
  componentId: "sc-ltx7l2-2"
})(["column-gap:8px;line-height:1;@media ", "{display:none;}"], styles/* device.laptopSmall */.Uh.laptopSmall);
var DesktopMenuLinksContainerStyles = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Menu__DesktopMenuLinksContainerStyles",
  componentId: "sc-ltx7l2-3"
})(["display:none;@media ", "{margin:auto;margin-right:3rem;display:flex;align-items:center;justify-content:space-between;column-gap:2rem;}"], styles/* device.laptopSmall */.Uh.laptopSmall);

var Menu = function Menu() {
  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      openMenu = _React$useState2[0],
      setOpenMenu = _React$useState2[1];

  var router = (0,next_router.useRouter)();

  var _React$useState3 = react.useState(false),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      stuck = _React$useState4[0],
      setStuck = _React$useState4[1];

  var _useTranslation = (0,esm/* useTranslation */.$G)("common"),
      t = _useTranslation.t;

  (0,react.useEffect)(function () {
    if (router.asPath === "/") {
      document.onscroll = function (e) {
        //@ts-ignore
        if (e.target.scrollingElement.scrollTop > 50) {
          setStuck(true);
          return;
        }

        setStuck(false);
      };
    } else {
      setStuck(true);
    }
  }, []);
  (0,react.useEffect)(function () {
    if (openMenu) {
      setOpenMenu(function (previous) {
        return !previous;
      });
    }
  }, [router.asPath]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Header, {
    id: "header",
    className: stuck ? "stuck transition" : "not-stuck transition",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Container, {
      className: "flex",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: "/",
        id: "logo",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(logo, {
          style: {
            cursor: "pointer"
          }
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DesktopMenuLinksContainerStyles, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DesktopMenuItem, {
          link: "/about-us",
          children: t("about us")
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DesktopMenuItem, {
          link: "/blog",
          children: t("blog")
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DesktopMenuItem, {
          link: "/services",
          submenu: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              className: router.locale === "ro" ? "active" : "",
              href: "/",
              locale: "ro",
              children: t("romanian")
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              className: router.locale === "en" ? "active" : "",
              href: "/",
              locale: "en",
              children: t("english")
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              className: router.locale === "ru" ? "active" : "",
              href: "/",
              locale: "ru",
              children: t("russian")
            })]
          }),
          children: t("language")
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        href: "https://admin.beelocals.com/login",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(styles/* Button */.zx, {
          className: "desktop-contact-us-button",
          children: t("Log in")
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(MobileMenuButton, {
        onClick: function onClick() {
          return setOpenMenu(function (previous) {
            return !previous;
          });
        },
        className: "flex center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(menu, {}), "Menu"]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(MobileMenuModal, {
        open: openMenu,
        setOpen: setOpenMenu
      })]
    })
  });
};

var DesktopMenuItem = function DesktopMenuItem(_ref) {
  var children = _ref.children,
      link = _ref.link,
      submenu = _ref.submenu;
  var router = (0,next_router.useRouter)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(MenuItem, {
    className: router.pathname.includes(link) ? 'active desktop-link' : "desktop-link",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: submenu ? "" : link,
      children: children
    }), submenu && /*#__PURE__*/(0,jsx_runtime.jsx)(SubMenuContainer, {
      children: submenu
    })]
  });
};

var SubMenuContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Menu__SubMenuContainer",
  componentId: "sc-ltx7l2-4"
})(["display:flex;align-items:center;justify-content:center;flex-direction:column;width:200px;height:fit-content;position:absolute;padding:0.5rem;top:calc(100% + 1rem);left:0;opacity:0;background-color:white;box-shadow:", ";transform:translateY(-10%);transition:all 0.15s ease-in-out;border-radius:1rem;pointer-events:none;>a{padding-left:0.75rem;display:flex;align-items:center;justify-content:flex-start;font-weight:600;font-size:0.9rem;border-radius:0.5rem;margin:auto;width:100%;color:", ";cursor:pointer;@media ", "{height:3rem;:hover{background:", "10;}}}"], styles/* shadow600 */.W5, styles/* MAINCOLOR */.Ku, styles/* device.laptopSmall */.Uh.laptopSmall, styles/* MAINCOLOR */.Ku);
var MenuItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Menu__MenuItem",
  componentId: "sc-ltx7l2-5"
})(["display:flex;align-items:center;justify-content:center;height:2.5rem;padding:0 1.5rem;color:", ";font-weight:600;cursor:pointer;border-radius:1rem;position:relative;::after{content:\"\";position:absolute;top:100%;left:0;width:100%;height:2rem;}:hover{background:", "10;color:", ";>div{opacity:1;transform:translateY(0%);pointer-events:all;}>svg{transform:scale(1.1);}}&.active,.active{position:relative;::before{content:\"\";position:absolute;width:5px;height:5px;right:10px;background-color:", ";border-radius:5px;}}"], styles/* MAINCOLOR */.Ku, styles/* MAINCOLOR */.Ku, styles/* MAINCOLOR */.Ku, styles/* MAINCOLOR */.Ku);
var MobileMenuModalHeaderStyles = (0,styled_components_browser_esm/* default */.ZP)(Container).withConfig({
  displayName: "Menu__MobileMenuModalHeaderStyles",
  componentId: "sc-ltx7l2-6"
})(["margin:0;position:auto;background:transparent;padding:0.75rem 1.5rem;>svg{cursor:pointer;}"]);

var MobileMenuModal = function MobileMenuModal(_ref2) {
  var open = _ref2.open,
      setOpen = _ref2.setOpen;

  var _React$useState5 = react.useState(false),
      _React$useState6 = (0,slicedToArray/* default */.Z)(_React$useState5, 2),
      openServices = _React$useState6[0],
      setOpenServices = _React$useState6[1];

  var _useTranslation2 = (0,esm/* useTranslation */.$G)("common"),
      t = _useTranslation2.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(MobileMenuModalStyles, {
    className: open ? "open transition" : 'transition',
    style: {
      opacity: open ? 1 : 0,
      transform: "translateY(".concat(open ? 0 : "-2rem", ")")
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(MobileMenuModalHeaderStyles, {
      style: {
        position: "static"
      },
      className: "flex",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        "aria-label": t("home"),
        href: "/",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(menuLogo, {})
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(styles/* Button */.zx, {
        onClick: function onClick() {
          return setOpen(function (previous) {
            return !previous;
          });
        },
        className: "flex center",
        style: {
          columnGap: "10px",
          background: "white",
          color: colors/* BLACKGREY */.oz
        },
        children: [t("close"), /*#__PURE__*/(0,jsx_runtime.jsx)(menu_close, {})]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(MobileLinkContainerStyles, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(MobileLinkStyles, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/blog",
          className: "main-title",
          children: t("blog")
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(MobileLinkStyles, {
        onClick: function onClick() {
          return setOpenServices(function (previous) {
            return !previous;
          });
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "main-title",
          children: [t("language"), /*#__PURE__*/(0,jsx_runtime.jsx)(arrowDown, {})]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Collapse/* default */.Z, {
          on: openServices,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(MobileSubMenuContainerStyle, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "/",
              locale: "ro",
              children: t("romanian")
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "/",
              locale: "en",
              children: t("english")
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "/",
              locale: "ru",
              children: t("russian")
            })]
          })
        })]
      })]
    })]
  });
};

var MobileSubMenuContainerStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Menu__MobileSubMenuContainerStyle",
  componentId: "sc-ltx7l2-7"
})(["padding-left:1rem;display:flex;flex-direction:column;row-gap:1rem;margin-top:0.5rem;>a{color:white;}"]);
var MobileMenuModalStyles = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Menu__MobileMenuModalStyles",
  componentId: "sc-ltx7l2-8"
})(["position:fixed;top:0;left:0;width:100%;height:100%;background:", ";z-index:2;flex-direction:column;align-items:center;justify-content:flex-start;opacity:0;transform:translateY(-2rem);pointer-events:none;&.open{opacity:1;transform:translateY(0);pointer-events:all;}"], styles/* MAINCOLOR */.Ku);
var MobileLinkContainerStyles = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Menu__MobileLinkContainerStyles",
  componentId: "sc-ltx7l2-9"
})(["padding:1.5rem;display:flex;flex-direction:column;width:100%;row-gap:1rem;align-items:flex-start;justify-content:flex-start;"]);
var MobileLinkStyles = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Menu__MobileLinkStyles",
  componentId: "sc-ltx7l2-10"
})(["border-bottom:1px solid white;width:100%;display:flex;flex-direction:column;padding-bottom:1rem;>.main-title{display:flex;align-items:center;justify-content:space-between;color:white;font-size:1.5rem;font-weight:500;>svg{height:20px;}}"]);
/* harmony default export */ var home_Menu = (Menu);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
;// CONCATENATED MODULE: ./components/home/Footer.js

 // import translate from '../../i18n/messages/translate';







var Badge = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Footer__Badge",
  componentId: "sc-17g71sw-0"
})(["width:150px;>img{height:50px;width:auto;}"]);
var Badges = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Footer__Badges",
  componentId: "sc-17g71sw-1"
})(["max-width:1350px;margin:auto;"]);
var Box = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Footer__Box",
  componentId: "sc-17g71sw-2"
})(["padding-top:50px;padding-bottom:50px;width:100%;"]);
var Footer_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Footer__Container",
  componentId: "sc-17g71sw-3"
})(["display:flex;flex-direction:column;justify-content:center;max-width:1350px;margin:auto;"]);
var Column = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Footer__Column",
  componentId: "sc-17g71sw-4"
})(["display:flex;flex-direction:column;text-align:left;>a{color:#ffffff;margin-bottom:20px;font-size:18px;text-decoration:none;&:hover{color:", ";transition:200ms ease-in;}}"], styles/* YELLOW */.$R);
var Row = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Footer__Row",
  componentId: "sc-17g71sw-5"
})(["display:grid;grid-template-columns:repeat(auto-fill,minmax(20%,1fr));grid-gap:20px;@media (max-width:1350px){grid-template-columns:repeat(auto-fill,minmax(200px,1fr));}"]);
var Heading = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "Footer__Heading",
  componentId: "sc-17g71sw-6"
})(["font-size:24px;color:#fff;margin-bottom:25px;font-weight:bold;"]);

var Footer = function Footer() {
  var _useTranslation = (0,esm/* useTranslation */.$G)("common"),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsx)("footer", {
    id: "footer",
    style: {
      background: styles/* MAINCOLOR */.Ku
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Box, {
      className: "sectionPadding",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Footer_Container, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Row, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Column, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading, {
              children: t("legal agreements")
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "/termeni",
              children: "Terms and Conditions"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "/privacy-policy",
              children: "Privacy Policy"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Column, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading, {
              children: t("contact")
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "mailto: info@beelocals.com",
              children: "info@beelocals.com"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "tel: +37369513786",
              children: "Tel: +37369513786"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Column, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading, {
              children: t("language")
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "/",
              locale: "ro",
              children: t("romanian")
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "/",
              locale: "ru",
              children: t("russian")
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "/",
              locale: "en",
              children: t("english")
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Column, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading, {
              children: t("others")
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "/blog",
              children: t("blog")
            })]
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Badges, {})]
    })
  });
};

/* harmony default export */ var home_Footer = (Footer);
;// CONCATENATED MODULE: ./components/general/Layout.tsx








var Layout = function Layout(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "color-scheme",
        content: "light only"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "icon",
        href: "/favicon.ico"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-icon",
        href: "/favicon.ico"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "theme-colot",
        content: styles/* MAINCOLOR */.Ku
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(home_Menu, {}), children, /*#__PURE__*/(0,jsx_runtime.jsx)(home_Footer, {})]
  });
};

/* harmony default export */ var general_Layout = (Layout);

/***/ }),

/***/ 6006:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6835);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9521);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);




var CollapseContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Collapse__CollapseContainer",
  componentId: "sc-ujye7t-0"
})(["transition:all 300ms cubic-bezier(0.4,0,0.2,1) 0ms;overflow:hidden;"]);

var Collapse = function Collapse(_ref) {
  var children = _ref.children,
      on = _ref.on;
  var divRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(0),
      _React$useState2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_React$useState, 2),
      height = _React$useState2[0],
      setHeight = _React$useState2[1];

  var _React$useState3 = react__WEBPACK_IMPORTED_MODULE_0__.useState("hidden"),
      _React$useState4 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_React$useState3, 2),
      overflow = _React$useState4[0],
      setOverflow = _React$useState4[1];

  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    if (on) {
      setHeight(divRef.current.scrollHeight);
      return;
    }

    setHeight(0);
    setOverflow("hidden");
  }, [on]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CollapseContainer, {
    className: "collapse-container",
    "aria-hidden": on ? false : true,
    onTransitionEnd: function onTransitionEnd() {
      return height > 0 ? setOverflow("visible") : null;
    },
    style: {
      height: height,
      overflow: overflow
    },
    ref: divRef,
    children: children
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Collapse);

/***/ }),

/***/ 7309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ku": function() { return /* binding */ MAINCOLOR; },
/* harmony export */   "My": function() { return /* binding */ BORDERCOLOR; },
/* harmony export */   "Q$": function() { return /* binding */ LIGHTGREY; },
/* harmony export */   "Sn": function() { return /* binding */ DARKGREY; },
/* harmony export */   "oz": function() { return /* binding */ BLACKGREY; },
/* harmony export */   "pD": function() { return /* binding */ GREYWHITE; }
/* harmony export */ });
/* unused harmony exports BLACK, WHITE, YELLOW, RED, GREEN */
var BLACK = "#000";
var WHITE = "#fff";
var BORDERCOLOR = "#D5DDE0";
var YELLOW = "#f2e10b";
var DARKGREY = "#686868";
var BLACKGREY = "#323C46";
var LIGHTGREY = "#C4C4C4";
var GREYWHITE = "#F5F5F5";
var RED = "#FF5252";
var MAINCOLOR = "#0074FF";
var GREEN = "#4AFF93";

/***/ }),

/***/ 6808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$R": function() { return /* binding */ YELLOW; },
/* harmony export */   "Cj": function() { return /* binding */ WHITE; },
/* harmony export */   "Ku": function() { return /* binding */ MAINCOLOR; },
/* harmony export */   "My": function() { return /* binding */ BORDERCOLOR; },
/* harmony export */   "Q$": function() { return /* binding */ LIGHTGREY; },
/* harmony export */   "Sn": function() { return /* binding */ DARKGREY; },
/* harmony export */   "Uh": function() { return /* binding */ device; },
/* harmony export */   "W5": function() { return /* binding */ shadow600; },
/* harmony export */   "ZA": function() { return /* binding */ GREEN; },
/* harmony export */   "hM": function() { return /* binding */ RED; },
/* harmony export */   "oz": function() { return /* binding */ BLACKGREY; },
/* harmony export */   "pD": function() { return /* binding */ GREYWHITE; },
/* harmony export */   "x2": function() { return /* binding */ InputStyle; },
/* harmony export */   "zx": function() { return /* binding */ Button; }
/* harmony export */ });
/* unused harmony exports BLACK, coloredShadow, InputButtonsGrid */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9521);

var BLACK = "#000";
var WHITE = "#fff";
var BORDERCOLOR = "#D5DDE0";
var YELLOW = "#f2e10b";
var DARKGREY = "#686868";
var BLACKGREY = "#323C46";
var LIGHTGREY = "#C4C4C4";
var GREYWHITE = "#F5F5F5";
var RED = "#FF5252";
var MAINCOLOR = "#0074FF";
var GREEN = "#4AFF93";
var shadow600 = "0px 20px 30px rgba(14, 36, 58, 0.1)";
var coloredShadow = "0 10px 20px -10px rgba(0, 116, 255, 0.5);";
var InputButtonsGrid = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "styles__InputButtonsGrid",
  componentId: "sc-16j296u-0"
})(["display:grid;grid-template-columns:repeat(auto-fit,auto);grid-gap:5vw;width:100%;>*{width:100%;}"]);
var device = {
  mobileSmallPortrait: "(min-width: 300px) and (orientation: portrait)",
  mobileLargePortrait: "(min-width: 370px) and (orientation: portrait)",
  mobileLandscape: "(min-width: 370px) and (orientation: landscape)",
  tabletSmallPortrait: "(min-width: 768px) and (orientation: portrait)",
  tabletLargePortrait: "(min-width: 1024px) and (orientation: portrait)",
  laptopSmall: "(min-width: 1024px) and (orientation: landscape)",
  laptopLarge: "(min-width: 1500px) and (orientation: landscape)",
  desktop: "(min-width: 2500px) and (orientation: landscape)"
};
var Button = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].button.withConfig */ .ZP.button.withConfig({
  displayName: "styles__Button",
  componentId: "sc-16j296u-1"
})(["padding:12px 20px;background-color:", ";color:white;border:none;border-radius:10rem;font-size:1rem;font-weight:600;min-height:42px;cursor:pointer;transition:all 0.3s ease-in-out;box-shadow:", ";&.small{padding:8px 16px;}&.ghost{border:1px solid ", ";background-color:transparent;color:", ";box-shadow:none;}&.text{border:none;background-color:transparent;color:", ";box-shadow:none;}:disabled{background-color:", ";color:", ";cursor:not-allowed;box-shadow:none;}@media ", "{padding:1.2rem 2rem;}@media ", "{padding:1rem 2rem;:hover{transform:scale(1.1);}}"], MAINCOLOR, coloredShadow, MAINCOLOR, MAINCOLOR, MAINCOLOR, LIGHTGREY, WHITE, device.tabletSmallPortrait, device.laptopSmall);
var InputStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].input.withConfig */ .ZP.input.withConfig({
  displayName: "styles__InputStyle",
  componentId: "sc-16j296u-2"
})(["min-height:4rem;display:flex;width:100%;align-items:center;justify-content:flex-start;border-radius:14px;font-size:1rem;padding:10px;background:", ";border:none;padding-left:20px;::placeholder{color:#9CA9B4;font-weight:500;}:hover{border:3px solid ", "20;}:focus{outline:none;border:3px solid ", "50;+ label{transform:translateY(0px);font-size:0.7rem !important;}}"], GREYWHITE, BLACKGREY, MAINCOLOR);

/***/ })

}]);